// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const membershipBenefit = {
  getMembershipBenefit(page,search,sort_order) {
    return AuthService.get(`/membership/membership_benefits?`+
      `page=${page}` +
      `&sort_order=${sort_order}` +
      `&search=${search}`
    );
  },
  showMembershipBenefit(id) {
    return AuthService.get(`/membership/membership_benefits/${id}`);
  },
  createMembershipBenefit(data) {
    return AuthService.post("/membership/membership_benefits", data);
  },
  updateMembershipBenefit(id, data) {
    return AuthService.put(`/membership/membership_benefits/${id}`, data);
  },
  deleteMembershipBenefit(id) {
    return AuthService.delete(`/membership/membership_benefits/${id}`);
  }
};
export default membershipBenefit;
